import { render, staticRenderFns } from "./ioc-tab-group.vue?vue&type=template&id=bde2f202&"
import script from "./ioc-tab-group.vue?vue&type=script&lang=js&"
export * from "./ioc-tab-group.vue?vue&type=script&lang=js&"
import style0 from "./ioc-tab-group.vue?vue&type=style&index=0&id=bde2f202&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports